// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","385":"component---src-templates-using-dsg-js"}[chunkId] + "-" + {"245":"a3c77b504938446d8871","385":"0caa39483d6f3f666d52"}[chunkId] + ".js";
};